import { t } from "i18next";

import { Match } from "../types";
import { formatTime } from "../lib/format";

export const shareMessage = (match: Match, closed = false): string => {
  const lines = [
    closed ? t("share.closedTitle") : t("share.openTitle"),
    "",
    `📍 ${match.location}`,
    `📅 ${match.date}`,
    `⏰ ${formatTime(match.time)}`,
  ];

  if (!closed) {
    lines.push(t("share.spotsLine", { count: match.spotsNeeded }));
  }

  if (match.note) {
    lines.push("", `📝 ${match.note}`);
  }

  lines.push(
    "",
    closed
      ? t("share.viewLink", { link: match.link })
      : t("share.confirmLink", { link: match.link })
  );

  return lines.join("\n");
};
